import './TournamentStructure.css'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { useEffect } from 'react'
import { memo } from 'react'

import { StageForm } from '../StageForm/StageForm'
import { StageCreation } from '../StageCreation/StageCreation'

const TournamentStructureComponent = (props) => {
	const creation = sessionStorage.getItem('activatedComponent')
	const activeComponent = useSelector(state => state.tournament.active)

	const [createStage, setCreatStage] = useState(false)

	useEffect(() => {
		setCreatStage(!activeComponent && !creation ? false : true)
	}, [activeComponent, creation])

	return (
		<>
			{
				props?.tournament?.stages_count > 0 && !createStage &&
					<StageForm
						stageNumber={props?.stageNumber}
						tournament={props?.tournament}
						auth={props?.auth}
						tournamentRefetch={props?.tournamentRefetch}
					/>
			}

			{
				(props?.tournament?.stages_count < 1 || createStage) && props?.auth &&
					<StageCreation tournament={props?.tournament} />
			}
		</>
	)
}

export const TournamentStructure = memo(TournamentStructureComponent)